import React from "react";
import { useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { useTeacherUpdate } from "../../Hooks/index";
function TeachersEdit() {
  const location = useLocation();

  const [form, setForm] = useState({});
  const [teacher, setTeacher] = useState([]);
  const { loading, formSubmit } = useTeacherUpdate();

  return (
    <div>
      <div className="card">
        <div className="card-baody m-4">
          <div className="d-flex justify-content-between">
            <h3>ویرایش مدرسین</h3>
            <div>
              <Link to="/User/ClassList/AddTeacher" className="btn btn-danger">
                + ایجاد مدرس
              </Link>
            </div>
          </div>{" "}
          <div className="row">
            {location.state.data.map((teacher, key) => {
              return (
                <div className="col-4" key={key}>
                  <div className="card">
                    <div className="card-body">
                      <div className="text-center">
                        <img
                          src={teacher.image}
                          style={{ width: "50%", height: "50%" }}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center m-3">
                        <span>نام مدرس</span>
                        <input
                          className="col-8 form-control"
                          defaultValue={teacher.name}
                          onChange={e => {
                            setForm({ ...form, name: e.target.value });
                          }}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center m-3">
                        <span> سابقه</span>
                        <input
                          className="col-8 form-control"
                          defaultValue={teacher.activity}
                          onChange={e => {
                            setForm({ ...form, activity: e.target.value });
                          }}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center m-3">
                        <span> مدارک</span>
                        <input
                          className="col-8 form-control"
                          defaultValue={teacher.proof}
                          onChange={e => {
                            setForm({ ...form, proof: e.target.value });
                          }}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center m-3">
                        <span> افتخارات</span>
                        <input
                          className="col-8 form-control"
                          defaultValue={teacher.cv}
                          onChange={e => {
                            setForm({ ...form, cv: e.target.value });
                          }}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center m-3">
                        <span> جزییات</span>
                        <input
                          className="col-8 form-control"
                          defaultValue={teacher.destails}
                          onChange={e => {
                            setForm({ ...form, destails: e.target.value });
                          }}
                        />
                      </div>
                      <div className="d-flex justify-content-between m-3">
                        <button
                          className="btn btn-success"
                          onClick={() => {
                            formSubmit({
                              ...form,
                              action: "edit",
                              teacher_id: teacher.id,
                            });
                          }}
                        >
                          ثبت ویرایش
                        </button>
                        <button
                          className="btn btn-warning"
                          onClick={() => {
                            formSubmit({
                              action: "delete",
                              teacher_id: teacher.id,
                            });
                          }}
                        >
                          حذف مدرس
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}{" "}
          </div>
          <div></div>
        </div>
      </div>
    </div>
  );
}

export default TeachersEdit;
